/**
 * 관리자 SPA 경로 (은폐용). API는 /api/admin 유지.
 * 배포 후 북마크·공유 주소: {PUBLIC_URL}/console-k7m2xq
 */
export const ADMIN_BASE_PATH = '/console-k7m2xq';

/** `/console-k7m2xq` 또는 `/console-k7m2xq/logs` … */
export function adminPath(...segments: string[]): string {
  const rest = segments
    .filter(Boolean)
    .map((s) => String(s).replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/');
  return rest ? `${ADMIN_BASE_PATH}/${rest}` : ADMIN_BASE_PATH;
}
